import { render } from "./Chat.vue?vue&type=template&id=726592f6"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
script.render = render

export default script